import { Log, WebStorageStateStore } from 'oidc-client-ts';

// Set logging level for OIDC client
if (process.env.NODE_ENV !== 'production') {
    Log.setLogger(console);
    Log.setLevel(Log.INFO);
}

export const getAuthSettings = () => ({
    authority: process.env.REACT_APP_AUTHORITY ?? 'https://preprodidentity.accessacloud.com',
    client_id: process.env.REACT_APP_CLIENT_ID ?? 'access.kitchenwizard.dev',
    client_secret: process.env.REACT_APP_CLIENT_SECRET ?? 'secret',
    redirect_uri: process.env.REACT_APP_REDIRECT_URI ?? 'http://localhost:5467/signin-oidc',
    response_type: process.env.REACT_APP_RESPONSE_TYPE ?? 'code',
    scope: process.env.REACT_APP_SCOPE ?? 'openid profile email',
    post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI ?? 'http://localhost:5467/',
    usePkce: true, // Enable PKCE for enhanced security
    userStore: new WebStorageStateStore({ store: window.localStorage })
});